/** Content from SureSpace_MASTER_Privacy_9_5.pdf */

export const PRIVACY_NOTICE_TITLE = 'SureSpace Privacy Notice';

export const PRIVACY_NOTICE_SECTIONS = [
  {
    title: '1. Introduction',
    body: 'SureSpace Technology FZE is committed to protecting personal data.',
  },
  {
    title: '2. Data Collected',
    body: 'Identity, contact, profile, and usage data may be collected.',
  },
  {
    title: '3. Use of Data',
    body: 'Data is used to operate, improve, and secure the platform.',
  },
  {
    title: '4. Interaction Data',
    body: 'Engagement patterns may be analyzed to improve performance.',
  },
  {
    title: '4.2 AI and Automated Processing (Wingman)',
    body: [
      'AI systems may analyze user data and behavior to generate recommendations and prompts.',
      'Messages are not continuously monitored, but limited review may occur for safety or compliance.',
      'Further details are described in the Terms and Conditions.',
    ],
  },
  {
    title: '5. Message Privacy',
    body: 'Messages are not actively monitored but may be reviewed in limited circumstances.',
  },
  {
    title: '6. Legal Basis',
    body: 'Processing is based on contract, legitimate interest, consent, or legal obligation.',
  },
  {
    title: '7. Data Sharing',
    body: 'Data may be shared with service providers or authorities where required.',
  },
  {
    title: '8. Data Retention and Account Deletion',
    body: [
      'Data is retained only as necessary. Dormant accounts may be deleted after inactivity with notice.',
      'Associated data may be permanently removed, with limited retention for legal purposes.',
    ],
  },
  {
    title: '9. User Rights',
    body: 'Users may access, correct, or delete their data.',
  },
  {
    title: '10. Security',
    body: 'Security measures include encryption and access controls.',
  },
];
